















































































































import { Vue, Component, Watch } from 'vue-property-decorator'

const countries = require("./countries")

import moment from "moment"
import { Profile } from '../account/types'
import { profileStore } from '../account/store'

@Component
export default class BasicInfo extends Vue {
  status: "updating" | "idle" = "idle"
  error: string = ""
  info: Partial<Profile> = {}

  inputValid = false

  countries = countries

  maxLegalDoB = moment().subtract(18, 'years').toISOString().substr(0, 10)

  dobMenu = false


  rules = {
    required: (value: string) => !!value || 'Required.',
    name: (value: string) => value.match(/\w+\s\w+/) || 'Required.',
    date: (value: string) => moment(value).isValid() || 'Please enter a valid date.',
  }

  mounted() {
    const profile = profileStore.state.profile
    if (profile === null) {
      console.error("Expected at least empty profile")
      this.$router.replace("/")
      return
    } else if (profile.name) {
      this.info = { ...profile }
    } else {
      this.info.user = profile.user
    }
  }

  updateProfile() {
    this.status = "updating";
    profileStore.update(this.info as Profile)
      .then(() => this.updateSuccess())
      .catch((e: Error) => this.updateFailure(e))
      .finally(() => this.status = "idle")
  }

  private updateSuccess() {
    this.$router.replace("/account")
  }

  private updateFailure(error: Error) {
    this.error = error.message
  }

  @Watch("dobMenu")
  showYearPicker(val: any) {
    val && setTimeout(() => ((this.$refs.picker as any).activePicker = 'YEAR'))
  }
}
